export default __webpack_public_path__ + "static/media/mastercard.2bb4f0e6.svg";